import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { CenteredFlexBox, ColumnFlexBox } from '../../FlexBox';
import { Paper, Typography } from '@mui/material';
import InfoOutlineRoundedIcon from '@mui/icons-material/InfoOutlineRounded';
import ProgressBar from '../../LinearProgress';
import IconButton from '../../Button/IconButton';
import TargetProgressDetails from './TargetProgressDetails';

const TargetProgressPaper = function TargetProgressPaper({ callTargets = {} }) {
  const intl = useIntl();
  const [detailsOpen, setDetailsOpen] = useState(false);

  const handleOpenDetails = () => {
    setDetailsOpen(true);
  };
  const handleCloseDetails = () => {
    setDetailsOpen(false);
  };

  return (
    <>
      <TargetProgressDetails
        open={detailsOpen}
        onClose={handleCloseDetails}
        title="BRANCH_TARGET_PROGRESS_DETAILS"
        data={callTargets?.branchTargets}
      />
      <Paper sx={{ padding: '6px 12px' }}>
        <ColumnFlexBox>
          <CenteredFlexBox gap="16px">
            <Typography
              variant="h6"
              sx={{ textAlign: 'start', fontSize: '16px' }}
            >
              {intl.messages.BRANCH_TARGET_PROGRESS}
            </Typography>
            <IconButton title="OPEN_DETAILS" onClick={handleOpenDetails}>
              <InfoOutlineRoundedIcon color="primary" />
            </IconButton>
          </CenteredFlexBox>
          <ProgressBar
            value={callTargets?.branchTargets?.answeredInTargetCount ?? 0}
            total={callTargets?.branchTargets?.target ?? 0}
            size="small"
            showPercentageInside
          />
        </ColumnFlexBox>
      </Paper>
    </>
  );
};

export default TargetProgressPaper;
